export default "__VITE_ASSET__7pmt1zYy__"